import React from 'react';

import { flightsAndAirlines as titles } from 'core/i18n';

const AirlinesHeader = () => (
  <div className="airline__header list__header">
    <div className="airline__header__tail-logo invisible">
      {titles.tailLogo}
    </div>
    <div className="airline__header__airline-name">{titles.airline}</div>
    <div className="airline__header__code">{titles.code}</div>
    <div className="airline__header__check-in">{titles.checkIn}</div>
  </div>
);

export default AirlinesHeader;
